import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthMiddleware = ({ component: Component, layout: Layout }) => {
  const loggedIn = useSelector((state) => state.Auth.loggedIn);

  return (
    <Route
      render={(props) => {
        // here you can apply condition
        if (!loggedIn) {
          return (
            <Redirect
              to={{ pathname: '/index', state: { from: props.location } }}
            />
          );
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
};

export default withRouter(AuthMiddleware);
